import { render } from "./IntroSecondView.vue?vue&type=template&id=3a996abc"
import script from "./IntroSecondView.vue?vue&type=script&lang=js"
export * from "./IntroSecondView.vue?vue&type=script&lang=js"

import "./IntroSecondView.vue?vue&type=style&index=0&id=3a996abc&lang=css"

import exportComponent from "C:\\wamp64\\www\\police-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__